import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const InstantPayoutsPromotionConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "instantPayoutsPromotion" */
      '../../../components/InstantPayoutsPromotion/InstantPayoutsPromotion'
    ),
  enabledKey: 'instant_payouts_promotion',
  htmlEvents: ['oninstantpayoutspromotionloaded', 'instantpayoutcreated'],
  customHtmlElementMethods: {
    setOnInstantPayoutsPromotionLoaded: {
      type: 'EventListenerMethod',
      event: 'oninstantpayoutspromotionloaded',
      isInternal: false,
      description:
        'Sets the event listener that allows a user to pass in a callback function for when the promotion is loaded.',
    },
    setOnInstantPayoutCreated: {
      type: 'EventListenerMethod',
      event: 'instantpayoutcreated',
      isInternal: false,
      description:
        'Sets the event listener that allows a user to pass in a callback function for when an instant payout is created.',
    },
  },
  enabledOverrideFlag: ComponentOverrideFlag.instant_payouts_promotion,
  syntheticTestInfo: {
    testUrl:
      'https://amp.corp.stripe.com/synthetics/us-west-2/instant-payouts-promotion',
  },
  docSitePath:
    '/connect/supported-embedded-components/instant-payouts-promotion',
  releaseState: 'ga',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description:
    'Displays promotional banner to encourage using instant payouts, along with a button to perform instant payouts.',
  friendlyName: 'Instant payouts promotion',
};
